import Vue from "vue";
import {downloadBase64url, getDataURL} from "@/helpers/download";
import _ from "lodash";
import {hasLocation, hasPermission} from "@/helpers/permissions";

export const downloadPackingSlipButtonBase = Vue.extend({
    props: {
        dispatchRequest: {required: true},
    },

    computed: {
        isAutoPrintLabelsEnabled() {
            return (this.dispatchRequest.dispatcher_enabled_cups_printer_types?.['labels'] ?? false)
                && hasPermission('orders.dispatchrequests.printlabels')
                && hasLocation(this.dispatchRequest.dispatcher_type, this.dispatchRequest.dispatcher_identifier, true)
        },
        isAutoPrintPackingSlipEnabled() {
            return (this.dispatchRequest.dispatcher_enabled_cups_printer_types?.['packing-slips'] ?? false)
                && hasPermission('orders.dispatchrequests.printlabels')
                && hasLocation(this.dispatchRequest.dispatcher_type, this.dispatchRequest.dispatcher_identifier, true)
        },
    },
})
